import React from "react";
import OCR from "./ocr";

export default function ImgText() {
  return (
    <div>
      <OCR />
    </div>
  );
}
